module.exports = __webpack_public_path__ + "static/media/44setecoqueiros.2406e05c.mp3";